<div class="quick-actions-row">
  <div class="quick-actions-chips">
    <ng-container *ngFor="let chip of chips">
      <!--
        Three mutually exclusive renderings, chained so each falls through to the
        next. They must nest rather than sit as siblings: two sibling `*ngIf ...;
        else plainChip` blocks would both instantiate `plainChip`, rendering every
        ordinary chip twice.
      -->

      <!--
        Assignee is the one chip with a true inline editor: app-order-owner-popover
        commits the reassignment straight away (and writes the activity entry),
        unlike company/location which live in the panel's save-on-confirm draft.
      -->
      <button
        *ngIf="chip.key === 'assignee' && chip.interactive; else notAssigneeChip"
        type="button"
        class="quick-action-chip"
        [matMenuTriggerFor]="ownerPopover.menu"
        (menuOpened)="ownerPopover.onOpen()"
      >
        <ng-container *ngTemplateOutlet="chipBody; context: { chip: chip }"></ng-container>
      </button>

      <ng-template #notAssigneeChip>
        <!--
          Shipping date is editable in place: the chip is the picker's trigger. The
          input sits alongside it, stretched over the chip's box but invisible —
          MatDatepicker anchors its overlay to the input element, so this is what
          makes the calendar open directly under the chip.
        -->
        <span class="quick-action-date" *ngIf="chip.datePicker; else plainChip">
          <button
            type="button"
            class="quick-action-chip"
            (click)="shippingPicker.open()"
          >
            <ng-container *ngTemplateOutlet="chipBody; context: { chip: chip }"></ng-container>
          </button>
          <input
            class="quick-action-date-anchor"
            [matDatepicker]="shippingPicker"
            [value]="shippingDateValue"
            (dateChange)="shippingDateChange.emit($event.value)"
            tabindex="-1"
            aria-hidden="true"
            readonly
          />
          <mat-datepicker #shippingPicker></mat-datepicker>
        </span>

        <ng-template #plainChip>
          <button
            type="button"
            class="quick-action-chip"
            [class.quick-action-chip--static]="!chip.interactive"
            [disabled]="!chip.interactive"
            (mouseenter)="showTip(chip, $event)"
            (mouseleave)="hideTip()"
            (focus)="showTip(chip, $event)"
            (blur)="hideTip()"
            (click)="onChipClick(chip)"
          >
            <ng-container *ngTemplateOutlet="chipBody; context: { chip: chip }"></ng-container>
          </button>
        </ng-template>
      </ng-template>
    </ng-container>
  </div>

  <div class="quick-actions-controls">
    <ui-table-column-settings
      class="quick-actions-picker"
      triggerIcon="sliders-horizontal"
      [columns]="pickerColumns"
      [maxVisible]="maxVisible"
      (columnsChange)="onPickerChange($event)"
    ></ui-table-column-settings>

    <button
      type="button"
      class="quick-actions-dismiss"
      (click)="hide.emit()"
      [attr.aria-label]="'quick_actions.hide' | translate"
      [matTooltip]="'quick_actions.hide' | translate"
      matTooltipClass="product-status-tooltip"
    >
      <ui-svg-icon svgIcon="close_icon" size="small"></ui-svg-icon>
    </button>
  </div>
</div>

<ng-template #chipBody let-chip="chip">
  <span
    class="quick-action-chip-avatar"
    *ngIf="chip.avatar; else chipIcon"
    [style.background-color]="chip.avatar.color"
  >{{ chip.avatar.initials }}</span>
  <ng-template #chipIcon>
    <ui-svg-icon
      *ngIf="chip.icon"
      class="quick-action-chip-icon"
      [svgIcon]="chip.icon"
      size="small"
    ></ui-svg-icon>
  </ng-template>

  <span class="quick-action-chip-label">{{ chip.label | translate }}</span>

  <!--
    Unresolved company/location: the amber tag carries only the word "Missing" —
    the field label already sits to its left, so repeating it would read twice.
  -->
  <span class="quick-action-chip-missing" *ngIf="chip.missing; else chipValue">
    <ui-svg-icon svgIcon="alert-circle" size="small"></ui-svg-icon>
    {{ 'quick_actions.missing' | translate }}
  </span>
  <ng-template #chipValue>
    <span
      class="quick-action-chip-value"
      [class.quick-action-chip-value--truncate]="chip.truncate"
    >{{ chip.value }}</span>
  </ng-template>

  <ui-svg-icon
    *ngIf="chip.expandable"
    class="quick-action-chip-affordance"
    svgIcon="chevron-down"
    size="small"
  ></ui-svg-icon>
  <ui-svg-icon
    *ngIf="chip.copyable"
    class="quick-action-chip-affordance"
    svgIcon="copy"
    size="small"
  ></ui-svg-icon>
</ng-template>

<!--
  Hover tooltip. Rendered fixed-position (coordinates taken from the chip's rect)
  rather than via matTooltip: Material's tooltip only accepts a flat string, and
  the location tooltip needs a second, smaller line for the address. Fixed
  positioning also escapes the row's `overflow: hidden`.
-->
<div
  class="quick-actions-tip"
  *ngIf="tip"
  [style.top]="tip.top"
  [style.left]="tip.left"
  role="tooltip"
>
  <span class="quick-actions-tip-title">{{ tip.title }}</span>
  <span class="quick-actions-tip-detail" *ngIf="tip.detail">{{ tip.detail }}</span>
</div>

<app-order-owner-popover
  #ownerPopover
  [order]="ownerTarget"
  (ownerChanged)="ownerChanged.emit($event)"
></app-order-owner-popover>
